import { BitrixVue } from 'ui.vue';
import type TileUploader from '../tile-uploader';

export const DropArea = BitrixVue.localComponent('drop-area', {
	mounted()
	{
		const tileUploader: TileUploader = this.$Bitrix.Application.get();
		tileUploader.getUploader().assignDropzone(this.$refs.dropArea);
		tileUploader.getUploader().assignBrowse(this.$refs.dropArea);
	},
	// language=Vue
	template: `
		<div class="disk-file-control-panel" ref="dropArea">
			<div class="disk-file-control-panel-btn-upload-box">
				<label class="disk-file-control-panel-btn-upload">Drag and Drop</label>
				<div class="disk-file-control-panel-btn-settings"></div>
			</div>
		</div>
	`
});
